import moment from 'moment'
export function gotLeftSlots(proposal) {
  let now = moment();
  let days = proposal.slots;
  if (!days || days.length === 0) return false;
  let slots = days[days.length - 1].slots;
  if (!slots) return false;

  return now < moment(slots[slots.length - 1].start);
}